module.exports = __webpack_public_path__ + "static/media/mitra-kalloo.4e1637ae.png";